import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum ReservationAttachmentTypeId {
  SIGNATURE = 1,
  DOCUMENT = 2,
  CONTRACT = 3,
  OTHER = 4,
  VACCINATION_CERTIFICATE = 5,
}

export class ReservationAttachmentType extends Codebook<ReservationAttachmentTypeId> {
  static readonly SIGNATURE = new ReservationAttachmentType(
    ReservationAttachmentTypeId.SIGNATURE,
    () => $t('Signature'),
    false,
  )
  static readonly DOCUMENT = new ReservationAttachmentType(
    ReservationAttachmentTypeId.DOCUMENT,
    () => $t('Document'),
    true,
  )
  static readonly CONTRACT = new ReservationAttachmentType(
    ReservationAttachmentTypeId.CONTRACT,
    () => $t('Contract'),
    true,
  )
  static readonly OTHER = new ReservationAttachmentType(
    ReservationAttachmentTypeId.OTHER,
    () => $t('Other'),
    true,
  )
  static readonly VACCINATION_CERTIFICATE = new ReservationAttachmentType(
    ReservationAttachmentTypeId.VACCINATION_CERTIFICATE,
    () => $t('Vaccination certificate'),
    false,
  )

  private constructor(
    public readonly id: ReservationAttachmentTypeId,
    public readonly name: () => string,
    public readonly isSelectable: boolean,
  ) {
    super(id)
  }

  static allSelectable = (): ReservationAttachmentType[] => {
    return ReservationAttachmentType.all().filter((type) => type.isSelectable)
  }
}
